import { useState } from 'react';

export default function useFlatPages(take: number = 20) {
	const [page, setPage] = useState(1);

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		page,
		setPage,
		getNextPage,
		pagination: {
			take,
			skip: (page - 1) * take,
		},
	};
}
